import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { firstValueFrom } from 'rxjs';
import { CustomValidator } from '../../../shared/validators/custom_validator';
import { ApiService } from '../../../core/services/api/api.service';
import { ToastService } from '../../../core/services/toast/toast.service';
import { EnfafInputComponent } from "../../enfaf-input/enfaf-input.component";
import { EnfafModalComponent } from '../../enfaf-modal/enfaf-modal.component';

@Component({
    selector: 'app-modal-change-password',
    imports: [ReactiveFormsModule, MatDialogModule, MatIconModule, MatButtonModule, EnfafModalComponent, EnfafInputComponent],
    templateUrl: './modal-change-password.component.html',
    styleUrl: './modal-change-password.component.scss'
})
export class ModalChangePasswordComponent implements OnInit {
  passwordForm!: FormGroup;
  //hideOldPassword = true;
  hidePassword = true;
  hideRepeatPassword = true;
  isSavingPassword = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalChangePasswordComponent>,
    private api: ApiService,
        private toast: ToastService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.passwordForm = new FormGroup(
      {
        //oldPassword: new FormControl(null, [Validators.required, Validators.minLength(6)]),
        password: new FormControl(null, [Validators.required, Validators.minLength(6)]),
        repeatPassword: new FormControl(null, [Validators.required, Validators.minLength(6)])
      },
      { validators: CustomValidator.matchesPassword }
    );
  }

  closeModal(result?: any): void {
    this.dialogRef.close(result);
  }

  onPasswordSaved(): void {
    this.closeModal();
  }

    async savePassword(): Promise<void> {
      try {
        if (this.passwordForm.invalid) {
          this.passwordForm.markAllAsTouched();
          return;
        }
        this.isSavingPassword = true;
        const body = this.passwordForm.value;
        const response = await firstValueFrom(this.api.createPassword(body));
        this.isSavingPassword = false;
        this.passwordForm.reset();
        this.toast.presentSuccessToast(response.message);
        this.onPasswordSaved();
      } catch (errorResponse: any) {
        this.isSavingPassword = false;
        const errorMessage = errorResponse?.error?.message;
        this.toast.presentErrorToast(errorMessage || 'Hubo un error cambiando tu contraseña');
        this.closeModal();
      }
    }

    // get oldPasswordIconSuffix() {
    //   return {
    //     icon: this.hideOldPassword ? 'eye-off' : 'eye',
    //     color: 'white',
    //     click: () => (this.hideOldPassword = !this.hideOldPassword)
    //   };
    // }
    get passwordIconSuffix() {
      return {
        icon: this.hidePassword ? 'eye-off' : 'eye',
        color: 'white',
        click: () => (this.hidePassword = !this.hidePassword)
      };
    }
    get repeatPasswordIconSuffix() {
      return {
        icon: this.hideRepeatPassword ? 'eye-off' : 'eye',
        color: 'white',
        click: () => (this.hideRepeatPassword = !this.hideRepeatPassword)
      };
    }
}
